// src/pages/Contentwriter.js
import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Contentbanner from "../Page-section/contentwriting/Contentbanner";
import Contentprocess from "../Page-section/contentwriting/Contentprocess";
import { useSEO } from "../hooks/useSEO";

function Contentwriter() {
  useSEO({
    title: "Content Writing Services for Business Growth | Leads & Sales",
    description:
      "Get expert content writing services that boost rankings, traffic & conversions. SEO-friendly blogs, website content & more. Free consultation available.",
    canonical: "https://empowerweb.in/content-marketing-services",
    ogTitle: "content writing services, blog writing services",
    ogDescription:
      "Expert content writing for websites, blogs, and marketing. SEO-optimized content that drives engagement and conversions.",
    keywords:
      "content writing services, blog writing services, seo content writer, article writing,  web content writing ",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <main>
        <Contentbanner />
        <Contentprocess />
      </main>
      <Footer />
    
    </div>
  );
}

export default Contentwriter;








